/* ═══ O POP-UP DE CAPTURA — [2026-08-17] ═════════════════════════════════════
   Portado de `rascunhos/home3.html`, com UMA diferença que é a razão de existir:
   lá o botão só trocava de passo; aqui ele ENVIA de verdade, pelo formulário
   nativo da Shopify, que é o que dispara os fluxos já cadastrados.

   🪤 O ENVIO É INTERCEPTADO, NÃO SUBSTITUÍDO. O `<form>` continua sendo o
     formulário da Shopify: se este arquivo não carregar, o navegador envia
     sozinho e o cadastro acontece — sai da página, mas não se perde o cliente.
     Pop-up que só cadastra com JS perde cadastro quando o JS quebra.
*/
(function () {
  'use strict';
  var pop = document.querySelector('[data-pop]');
  if (!pop) return;

  var param = new URLSearchParams(location.search).get('pop');
  var aberto = false;
  /* segundos do Editor (padrão 10): espera na página E espera depois da resposta ao cookies */
  var esperaMs = (parseInt(pop.dataset.segundos, 10) || 10) * 1000;

  /* ═══ A MEMÓRIA DO POP-UP — refeita em [2026-09-08] ════════════════════════
     Ele: *"não é uma vez por aba. Tem que abrir uma vez; se a pessoa já falou
     que não quer o desconto, só quando ela sair do site e voltar de novo é que
     vai abrir pra ela."*
     🔴 ERA `sessionStorage`, e essa é a causa do defeito que ele relatou como
       "pop-up aparecendo infinitamente". `sessionStorage` MORRE quando a aba
       fecha: aba nova = memória zerada = pop-up de novo. Ele revisa o site
       abrindo o preview em abas novas o tempo todo, então via sempre. Para o
       cliente é igual: quem visita a loja três vezes na semana via três vezes.
     👉 `localStorage` com CARIMBO DE HORA. Três desfechos, três regras:
        · assinou  → nunca mais (já tem o cupom; insistir é ofensa)
        · recusou  → volta só numa visita futura
        · só viu   → idem
     🪤 O `sessionStorage` CONTINUA sendo gravado, e não é redundância: o
       `ettore-convite.js` lê essa chave para saber se o cupom ainda vem nesta
       sessão. Trocar sem manter isso quebraria o convite do quiz em silêncio. */
  var CHAVE = 'ettore-pop-v2';
  /* [2026-09-20] Ele: "se o cliente recusou uma vez, só vai aparecer para ele daqui a 15 dias… não pode ficar abrindo toda
     hora". Antes recusar valia 6 h. Medido antes da correção (fluxo-popups.mjs): fechar e rolar REABRIA na mesma página. */
  /* [2026-09-08] Ele: *"se a pessoa já cadastrou, só mostra pra ela de novo daqui
     15 dias. Ela já entrou no fluxo, a gente já disparou o e-mail. Não tem por que
     ficar mostrando toda hora — a não ser que ela volte e às vezes já esqueceu."*
     🔴 Eu tinha posto NUNCA MAIS. Não é: 15 dias é prazo, não é adeus. */

  function memoria() {
    try { return JSON.parse(localStorage.getItem(CHAVE) || 'null'); } catch (e) { return null; }
  }
  function lembra(acao) {
    try { localStorage.setItem(CHAVE, JSON.stringify({ acao: acao, quando: Date.now() })); } catch (e) {}
    /* 🪤 [2026-09-08] AQUI ESTEVE `lembra('viu')` POR DESCUIDO MEU, e o pop-up
       morria com "Maximum call stack size exceeded" — a função chamava a si
       mesma. A troca por texto casou aqui em vez de casar no `abre()`, porque
       o padrão bateu no trecho que eu MESMO tinha acabado de inserir.
       👉 Depois de substituir por texto, procurar o padrão de novo no arquivo. */
    try { sessionStorage.setItem('ettore-pop', '1'); } catch (e) {}
  }
  /* [2026-10-09] Ele: pop-up "1× por visitante" — abriu uma vez (viu, recusou ou assinou), não volta mais neste navegador.
     Supera os prazos de 24 h / 15 dias (comentários acima). ?pop=1 continua forçando. */
  function jaResolvido() {
    return !!memoria();
  }
  var visto = jaResolvido();

  /* 🪤 NUNCA POR CIMA DO BANNER DE COOKIES SEM RESPOSTA: os dois brigam pelo
     mesmo canto/atenção, e sobrepor cupom em cima de "aceitar cookies" é
     pedir cadastro antes da pessoa nem ter decidido se aceita ser rastreada.
     Se o banner ainda está de pé, `abre()` desiste por agora e volta a
     tentar sozinho assim que a Shopify avisar que a pessoa respondeu. */
  function bannerAberto() {
    /* 🪤 NÃO USAR offsetParent: para elemento `position:fixed` (o caso do
       banner) ele SEMPRE devolve null, mesmo visível — daria falso negativo
       sempre. getClientRects() reflete o que está realmente desenhado. */
    var b = document.querySelector('#shopify-pc__banner');
    return !!(b && b.getClientRects().length > 0);
  }

  var relogio = null, porRolagem = null;   /* os gatilhos, para fecha() poder desligá-los */
  /* quem FORÇA a abertura (?pop=1, a volta do cadastro com o cupom, o erro do formulário) zera `visto`: abre() respeita */
  function forcado() { return visto === false && forcouAbrir; }
  var forcouAbrir = false;
  function desligaGatilhos() {
    if (relogio) { clearTimeout(relogio); relogio = null; }
    if (porRolagem) { window.removeEventListener('scroll', porRolagem); porRolagem = null; }
  }
  function abre() {
    /* 🔴 [2026-09-20] ERA `if (visto || aberto)`, com `visto` calculado UMA vez na carga: depois de fechar, o gatilho de rolagem
       (que seguia ouvindo se o relógio disparou primeiro) chamava abre() de novo e a memória "recusou" era sobrescrita por "viu".
       Medido: fechou → rolou 50% → reabriu. Agora a memória é consultada na hora, e fecha() desliga os gatilhos. */
    if (aberto) return;
    if (!forcado() && jaResolvido()) return;
    /* 🪤 NUNCA POR CIMA DA GAVETA DO CARRINHO: é uma conversa já começada, e
       cobri-la com um cupom é interromper quem já ia comprar. */
    if (document.querySelector('.ett-gav[data-aberta]')) return;
    aberto = true;
    pop.hidden = false;
    /* dois quadros antes de animar: o navegador precisa ter pintado o estado
       inicial para a transição existir */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { pop.classList.add('vivo'); });
    });
    lembra('viu');
  }

  /* 🪤 QUEM CHAMA DE FORA CHAMA ESTA, NUNCA `abre()` DIRETO. `visitorConsentCollected`
     só dispara UMA vez por resposta — se a checagem de banner ficasse dentro de
     `abre()`, o próprio callback do evento reconferia o banner, via de regra
     ainda via ele "de pé" (a Shopify some com uma transição, não é instantâneo),
     registrava outro listener pra um evento que nunca mais vem, e o pop-up
     ficava esperando pra sempre. Medido isso perdendo o pop-up de vez em quando
     mesmo depois de aceitar. Por isso o callback do evento chama `abre()` direto,
     sem reconferir.
     ⏱️ [2026-10-03] Ele: *"está abrindo logo depois que fecha o cookies… uns 10 segundos
       depois, quando a pessoa estiver mexendo mais no site"*. Era `abre` direto no evento:
       quem demorava a responder ao cookies levava o cupom NO MESMO CLIQUE do "Aceitar".
       Agora a resposta ao cookies zera o relógio: o pop-up vem `segundos` DEPOIS dela. */
  function tentaAbrir() {
    if (bannerAberto()) {
      document.addEventListener('visitorConsentCollected', function () {
        setTimeout(abre, esperaMs);
      }, { once: true });
      return;
    }
    abre();
  }

  function fecha() {
    pop.classList.remove('vivo');
    aberto = false;
    desligaGatilhos();
    setTimeout(function () { pop.hidden = true; }, 420);
  }

  pop.addEventListener('click', function (e) {
    if (e.target.closest('[data-pop-fecha]')) {
      e.preventDefault();
      /* fechar no X ou no "não quero desconto" é resposta: não insiste nesta visita */
      lembra('recusou');
      fecha();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !pop.hidden) { lembra('recusou'); fecha(); }   /* [20/09] Esc é resposta, como o X */
  });

  /* ⏱️ [2026-10-03] SÓ O RELÓGIO. Havia também "ou depois de rolar 25%", o que vier primeiro —
     no celular 25% se rola em 2 s e o pop-up atropelava quem mal tinha chegado. A rolagem saiu
     (o campo do schema também; nem o ar nem o rascunho tinham valor gravado). */
  if (param === '1') { visto = false; forcouAbrir = true; setTimeout(tentaAbrir, 300); }
  else if (param !== '0' && !visto) {
    relogio = setTimeout(function () { relogio = null; tentaAbrir(); }, esperaMs);
  }

  /* ── o envio ──
     🔴 NÃO USAR fetch AQUI. Medido: a Shopify devolve 400 "Missing CAPTCHA
       token". Ela injeta o token no envio NORMAL do formulário; por fetch o
       token não existe e o cadastro é recusado sem nada aparecer na tela.
       Então o formulário envia como formulário e a página volta com
       `?customer_posted=true` — e é aí que o passo 2 aparece. */
  var campo = pop.querySelector('[data-pop-email]');
  var erro = pop.querySelector('[data-pop-erro]');
  var form = pop.querySelector('.pop-form-raiz');

  if (form) form.addEventListener('submit', function (e) {
    /* validação só para não gastar um recarregamento com e-mail torto */
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test((campo.value || '').trim())) {
      e.preventDefault();
      erro.textContent = 'Confira o e-mail — parece faltar alguma coisa.';
      erro.hidden = false;
      campo.focus();
      return;
    }
    /* 🔴 [2026-09-12] QUEM POSTOU FICA MARCADO. O `?customer_posted=true` da volta é o
       mesmo para este formulário e para o do quiz; sem a marca, os DOIS reagiam — ele
       viu: deu o e-mail aqui e a tela de resultado do quiz reabriu por cima do cupom,
       porque tinha feito o quiz na mesma sessão. Cada um só volta se foi ele que postou. */
    try { sessionStorage.setItem('ettore-postou', 'pop'); } catch (e) {}
  });

  /* ── a volta ── */
  var busca = new URLSearchParams(location.search);
  var quemPostou = '';
  try { quemPostou = sessionStorage.getItem('ettore-postou') || ''; } catch (e) {}
  if (busca.get('customer_posted') === 'true' && quemPostou !== 'quiz') {
    /* 🪤 a marca só sai DEPOIS de o quiz também ter lido: apagar aqui na hora fazia o
       quiz achar a marca vazia e reabrir por cima do cupom (medido em 12/09). */
    setTimeout(function () { try { sessionStorage.removeItem('ettore-postou'); } catch (e) {} }, 30000);
    /* 🪤 A SESSÃO NÃO PODE CALAR ESTA ABERTURA. `abre()` desiste se já mostrou
       o pop-up nesta sessão — e mostrou, foi por ele que a pessoa se cadastrou.
       Aqui o pop-up TEM de voltar, senão a pessoa dá o e-mail e não recebe o
       cupom que a gente prometeu. */
    visto = false; forcouAbrir = true;
    passo2();
    tentaAbrir();
    /* deu o e-mail: o cupom é dela, o pop-up não volta mais */
    lembra('assinou');
    /* tira o parâmetro do endereço para um F5 não reabrir o cupom para sempre */
    if (history.replaceState) {
      busca.delete('customer_posted');
      var q = busca.toString();
      history.replaceState({}, '', location.pathname + (q ? '?' + q : '') + location.hash);
    }
  } else if (pop.querySelector('[data-pop-erro-liquid]')) {
    visto = false; forcouAbrir = true;
    tentaAbrir();
  }

  function passo2() {
    pop.querySelector('[data-pop-passo="1"]').classList.add('oculto');
    pop.querySelector('[data-pop-passo="2"]').classList.remove('oculto');
  }

  var cupom = pop.querySelector('[data-pop-cupom]');
  if (cupom) cupom.addEventListener('click', function () {
    var cod = pop.querySelector('[data-pop-cod]').textContent.trim();
    var b = cupom.querySelector('button');
    var feito = function () {
      cupom.classList.add('feito'); b.textContent = 'Copiado';
      setTimeout(function () { cupom.classList.remove('feito'); b.textContent = 'Copiar'; }, 1800);
    };
    if (navigator.clipboard) navigator.clipboard.writeText(cod).then(feito, feito);
    else feito();
  });
})();
